import React, { useState, useEffect, useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import heatmapModule from 'highcharts/modules/heatmap';
import Select from 'react-select';
import redirectURL from "../redirectURL"

heatmapModule(Highcharts);

const CFAHeatmap = ({chartData,startDate, endDate}) => {

  const [rawData ,setRawData] = useState(chartData)
  const skuList = Array.from(new Set(rawData.map(d => d.sku_code)));
  // const cfaList = Array.from(new Set(rawData.map(d => d.destination_store_name)));
  const cfaList = useMemo(() => {
    const totals = rawData.reduce((acc, curr) => {
      acc[curr.destination_store_name] = (acc[curr.destination_store_name] || 0) + curr.sale_quantity;
      return acc;
    }, {});

  return Object.entries(totals)
    .sort((a, b) => a[1] - b[1]) // Descending sort by total sale quantity
    .map(([store]) => store);
}, [rawData]);



 const destinationOptios = [
    { value: null, label: 'ALL' },
    { value: 5, label: 'Top 5' },
  ];

  const productOptions = [
    { value: 10, label: 'Top 10 Sku`s' },
    { value: 20, label: 'Top 20 Sku`s' },
    { value: null, label: 'Top 50 Sku`s' },
    // { value: 50, label: 'Top 50' },
  ];

  const [topProducts, setTopProducts] = useState(productOptions[productOptions.length - 1]); // Show All
  const [topCFAs, setTopCFAs] = useState(destinationOptios[0]); // Show All

  const filteredSKUs = topProducts.value ? skuList.slice(0, topProducts.value) : skuList;
  const filteredCFAs = topCFAs.value ? cfaList.slice(0, topCFAs.value) : cfaList;

  const heatmapData = useMemo(() => {
    return filteredCFAs.flatMap((store, y) =>
      filteredSKUs.map((sku, x) => {
        const match = rawData.find(d => d.sku_code === sku && d.destination_store_name === store);
        return [x, y, match ? match.sale_quantity : 0];
      })
    );
  }, [filteredSKUs, filteredCFAs]);

  const allDates = [
    ...new Set(
      chartData
        .map((d) => d.invoice_date && d.invoice_date.slice(0, 10))
        .filter(Boolean)
    ),
  ].sort();
  const [fromDate, setFromDate] = useState(startDate);
  const [toDate, setToDate] = useState(endDate);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);

  const chartOptions = {
    chart: {
      type: 'heatmap',
      height: 500,
      marginTop: 100,
      marginBottom: 80,
      plotBorderWidth: 1,
    },
    title: {
      text: "Destinations's vs SKU Sales Heatmap",
      align: 'center',
      y: 30,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
      },
    },
    xAxis: {
      categories: filteredSKUs,
      title: {
        text: 'SKU',
        align: 'middle',
        y: -60,
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: '#333',
        },
      },
      labels: {
        rotation: -45,
      },
      opposite: true,
    },
    yAxis: {
      categories: filteredCFAs,
      title: {
        text: 'Destination Store Location',
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: '#333',
        },
      },
    },
    colorAxis: {
      min: 0,
      minColor: '#FFF5C3',
      maxColor: '#E25822',
    },

    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      y: 85,
      symbolHeight: 320,
      symbolWidth: 12,
      symbolPadding: 5,
      // reversed: true,
      colorAxis: {
      min: 0,
      minColor: '#FFF5C3',
      maxColor: '#E25822',
      reversed: true, // 🔁 Flip the color gradient scale
    },

      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px',
      },
    },


    tooltip: {
      formatter: function () {
        return `<b>Destination:</b> ${filteredCFAs[this.point.y]}<br/>
                <b>SKU:</b> ${filteredSKUs[this.point.x]}<br/>
                <b>Quantity:</b> ${this.point.value}`;
      },
    },
    credits: { enabled: false },
    series: [
      {
        name: 'Sales Volume',
        borderWidth: 1,
        borderColor: '#FEF0BE',
        data: heatmapData,
        dataLabels: {
          enabled: false,
        },
      },
    ],
  };

     useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        from_date: fromDate,
        to_date: toDate,
      };

      const dailySalesResponse = await redirectURL.post("inventory/getTop50DailySalesChartData", params);
      
      if (dailySalesResponse.status === 200) {
        if (dailySalesResponse.data.status === "success") {
          setRawData(JSON.parse(dailySalesResponse.data.data.drilldown_df) || []);
        }
      }
    } catch (err) {
      alert('Failed to call API');
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [fromDate, toDate, topProducts]);


  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <div style={{ width: '200px'}}>
          <label style={{ fontWeight: 600, fontSize: 16,marginBottom: 4  }}>Select Top Destinations</label>
          <Select options={destinationOptios} value={topCFAs} onChange={setTopCFAs} />
        </div>

        <div style={{ width: '200px' }}>
          <label style={{ fontWeight: 600, fontSize: 16,marginBottom: 4  }}>Select Top SKU`s</label>
          <Select 
            options={productOptions} 
            value={topProducts} 
            onChange={setTopProducts} 
          />
        </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <label style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>From Date:</label>
          <input
            id="from-date-heatMap"
            type="date"
            value={fromDate}
            min={startDate}
            max={toDate}
            onChange={e => setFromDate(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: '1px solid #ccc',
              fontSize: 14,
              background: '#fff',
              marginBottom: 0,
              minWidth: 140
            }}
            onClick={() => {
              const dateInput = document.getElementById('from-date-heatMap');
              if (dateInput && dateInput.showPicker) {
                dateInput.showPicker();
              }
            }}
            // disabled={allDates.length === 0}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <label style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>To Date:</label>
          <input
            id="to-date-heatMap"
            type="date"
            value={toDate}
            min={fromDate}
            max={endDate}
            onChange={e => setToDate(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: '1px solid #ccc',
              fontSize: 14,
              background: '#fff',
              marginBottom: 0,
              minWidth: 140
            }}
            onClick={() => {
              const dateInput = document.getElementById('to-date-heatMap');
              if (dateInput && dateInput.showPicker) {
                dateInput.showPicker();
              }
            }}
            // disabled={allDates.length === 0} 
          />
        </div>
      </div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default CFAHeatmap;
